import React from 'react';
import MonthlyViewNavigation from './MonthlyViewNavigation';
import PageLayout from './PageWithLeftNavLayout';

const MonthlyViewLayout = ({ date, children }) => {
  return (
    <PageLayout leftNav={<MonthlyViewNavigation date={date} />}>
      {children}
    </PageLayout>
  );
};

export default MonthlyViewLayout;
